export default __webpack_public_path__ + "static/media/bucket.6878fca4.svg";